import { ASSET_TYPE, IAsset, searchAssets } from '@desp-aas/desp-ui-fwk';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../redux';

export function usePopularAssets(asset_type: ASSET_TYPE) {
    const [loading, setLoading] = useState(false);
    const [assets, setAssets] = useState<IAsset[] | undefined>();
    const [offset, setOffset] = useState(0);

    const appWidth = useSelector((s: ReduxState) => s.app.width);
    const isMobile = !!(appWidth && appWidth <= 800);
    const pageSize = isMobile ? 1 : 3;
    const maxOffset = assets ? Math.max(0, assets.length - pageSize) : 0;

    useEffect(() => {
        setLoading(true);
        setOffset(0);
        searchAssets({ limit: 12, type: asset_type, q: '', sorts: 'likes_count' })
            .then((res) => setAssets(res.assets))
            .finally(() => setLoading(false));
    }, [asset_type]);

    const prev = useCallback(() => setOffset((o) => Math.max(0, o - 1)), []);
    const next = useCallback(() => setOffset((o) => Math.min(maxOffset, o + 1)), [maxOffset]);

    return { loading, assets, offset, isMobile, prev, next, maxOffset };
}
